import {SafeAny} from '@/types';
import {http} from '@/utils';
import {getAdjustAttribution} from '@/utils/adjust';
import type {
  BalanceListItem,
  PayMethod,
} from '@fe-progressive/package-progressive/recharge';

export type {BalanceListItem, PayMethod};

export interface IncomeModel {
  /**
   * 金额充值ID
   */
  balanceId: string | 0;
  /**
   * 支付方式ID，目前默认UPI 传2
   */
  payTypeId: string;
  /**
   * 自定义金额，自定义金额 则balanceId传0
   */
  rechargeBalance: string | 0;

  // UPI: PAYTM_UPI_ONLY_PAYTM
  payTag: string;

  /**
   * 1 UPI 2 Crypto
   */
  payCategory?: number;
}

export interface IncomeResModel {
  orderNo: string;
  packageId: number;
  upiId: string;
}

export interface PayCallbackModel {
  /**
   *  订单号
   */
  orderNo: string;
  /**
   *  支付结果: 1
   */
  tradeResult: string;
  /**
   * URT
   */
  approvalUrt: string;
}

export const getBalanceList = (useType?: number) => {
  return http.post<{useType?: number}, BalanceListItem[]>(
    'app/pay/balance/list',
    {useType},
  );
};

export const goIncome = (incomeData: IncomeModel) => {
  return http.post<IncomeModel, string | IncomeResModel>(
    'app/pay/income',
    incomeData,
  );
};

export const getPayMethod = (useType?: number) => {
  const attribution = getAdjustAttribution();
  return http.post<{channelUser: number; useType?: number}, PayMethod[]>(
    'app/pay/type/active/list',
    {
      channelUser:
        attribution?.tracker_name &&
        attribution.tracker_name.toLowerCase() !== 'organic'
          ? 1
          : 0,
      useType,
    },
  );
};

export const paySuccess = (payCallback: PayCallbackModel) => {
  return http.post<SafeAny>('app/callback/upi/result', payCallback);
};
